const MINOR_DIGITS: Record<string, number> = { COP: 2, USD: 2, EUR: 2, MXN: 2, PEN: 2, CLP: 0 };

export function minorDigits(currency: string): number {
  return MINOR_DIGITS[currency] ?? 2;
}

export function formatMoney(minor: number, currency: string, locale = 'es-CO'): string {
  const digits = minorDigits(currency);
  const value = minor / 10 ** digits;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: currency === 'COP' ? 0 : digits,
    minimumFractionDigits: currency === 'COP' ? 0 : digits,
  }).format(value);
}

/** Major units typed by a person (e.g. "12500.5") → integer minor units for the API. */
export function toMinor(major: number | string, currency: string): number {
  return Math.round(Number(major) * 10 ** minorDigits(currency));
}

/** Integer minor units → major units, for pre-filling editable inputs. */
export function fromMinor(minor: number, currency: string): number {
  return minor / 10 ** minorDigits(currency);
}
